import { useEffect } from "react";

import { DEFAULT_SHOP_SORT, type ShopSort } from "@/lib/shop-catalog-view";
import {
  SHOP_CATEGORY_QUERY_PARAM,
  SHOP_SORT_QUERY_PARAM,
} from "@/lib/shop-links";

/**
 * Mirror the shop's category filter and sort into the address bar, so a
 * product page link back (or the browser's Back button) restores them.
 */
export function useShopBrowseUrlSync({
  enabled,
  category,
  sort,
}: {
  enabled: boolean;
  category?: string;
  sort: ShopSort;
}) {
  useEffect(() => {
    if (!enabled) return;
    const url = new URL(window.location.href);
    if (category) url.searchParams.set(SHOP_CATEGORY_QUERY_PARAM, category);
    else url.searchParams.delete(SHOP_CATEGORY_QUERY_PARAM);
    if (sort !== DEFAULT_SHOP_SORT) {
      url.searchParams.set(SHOP_SORT_QUERY_PARAM, sort);
    } else {
      url.searchParams.delete(SHOP_SORT_QUERY_PARAM);
    }
    if (url.href !== window.location.href) {
      window.history.replaceState(window.history.state, "", url.href);
    }
  }, [enabled, category, sort]);
}
